import React from 'react';
import Navbar from '../components/Navbar';
import HeroSection from '../components/home/HeroSection';
import ShiftSection from '../components/home/ShiftSection';
import PlatformOverview from '../components/home/PlatformOverview';
import TalentIntelligence from '../components/home/TalentIntelligence';
import IndustryFit from '../components/home/IndustryFit';
import WhiteGloveSupport from '../components/home/WhiteGloveSupport';
import ClosingCTA from '../components/home/ClosingCTA';
import Footer from '../components/Footer';
import AnimatedBackgroundDirectional from '../components/AnimatedBackgroundDirectional';
import SEO from '../components/SEO';
import StructuredData from '../components/StructuredData';

const NewHomePage = () => {
  return (
    <div className="min-h-screen bg-black text-white">
      <SEO 
        title="Traain | Enterprise Training & Enablement Platform"
        description="Build world-class teams with Traain. Create predictable, compliant teams and outcomes powered by Navigator AI™. Enterprise training, role-play, and enablement platform."
        keywords="enterprise training platform, AI training software, employee enablement, role-play training, LMS alternative, performance enablement, enterprise learning, Navigator AI"
      />
      <StructuredData type="organization" />
      {/* Animated Background - Same as product pages */}
      <div className="fixed inset-0 z-0">
        <AnimatedBackgroundDirectional direction="diagonal" />
      </div>

      {/* Content */}
      <div className="relative z-10">
        <Navbar />
        <HeroSection />
        <ShiftSection />
        <PlatformOverview />
        <TalentIntelligence />
        <IndustryFit />
        <WhiteGloveSupport />
        <ClosingCTA />
        <Footer />
      </div>
    </div>
  );
};

export default NewHomePage;
